export enum Type {
    SUGGESTION = 'suggestion',
    PROBLEM = 'problem',
    QUESTION = 'question',
}
